import { prepareSubject } from './prepareSubject';
import { prepareTroubledOffer } from './prepareTroubledOffer';
import { prepareAttachmentsTokens } from './prepareAttachmentsTokens';
import { prepareOffer } from './prepareOffer';
import { preparePlacesOffers } from './preparePlacesOffers';
export function prepareParameters(parameters) {
  var formValue = parameters.formValue,
    referenceLink = parameters.referenceLink;
  return {
    email: formValue.email || '',
    phone: formValue.phone,
    oldPhone: formValue.phone,
    currentPhone: formValue.newPhone,
    placesOffers: preparePlacesOffers(formValue),
    text: formValue.message || '',
    userName: formValue.name,
    subject: prepareSubject(formValue),
    offer: prepareOffer(formValue),
    troubledOffer: prepareTroubledOffer(formValue),
    attachmentsTokens: prepareAttachmentsTokens(formValue),
    locationUrl: referenceLink || window.location.href,
    partnerRewardsSource: formValue.partnerRewardsSource
  };
}